module.exports = __webpack_public_path__ + "img/9788996575528.819b3742.jpg";